import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { flattenPicks } from '../../../../../core/utils';
import { IFullBetslip } from '../../../../bet-generation/models';
import { BetslipTypePickErrors, IBetslipPickErrors, emptyPickErrors } from '../../../state';
import { PickValidationComposerService } from './pick-validation-composer.service';

@Injectable()
export class PicksValidationService {
    constructor(private compositeValidator: PickValidationComposerService) {}

    validatePicks(fullBetslip: IFullBetslip, state: IBetslipState): BetslipTypePickErrors {
        return Object.values(fullBetslip.typeBetslips).reduce((acc, betslip) => {
            if (betslip.slips.length === 0) {
                return acc;
            }

            const picks = betslip.slips.flatMap((slip) => Object.values(slip.slipPicks)).map((sp) => sp.pick);
            const flatPicks = flattenPicks(picks);

            if (flatPicks.length === 0) {
                return acc;
            }

            const result: IBetslipPickErrors = {};

            for (const pick of flatPicks) {
                const pickId = pick.id.toString();

                if (result[pickId]) {
                    continue;
                }

                result[pickId] = this.compositeValidator.validatePick(pick, betslip.type, state);
            }

            acc[betslip.type] = result;

            return acc;
        }, emptyPickErrors());
    }
}
